import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import AdvanceRefundForm from './AdvanceRefundForm'
import AdvanceRefundTable from './AdvanceRefundTable'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import {
  saveExpenseRequest,
  deleteExpenseRequest,
  downloadExpenseRecordVoucherFile,
} from '../../redux/actions/accountingExpenseRequest'
import { useHistory } from 'react-router-dom'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import moment from 'moment'
import { sessionGetItemJSON, sessionRemoveItem } from '../../utils/sessionHelpers'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import AdvanceRefundView from './AdvanceRefundView'
import { previewFile } from '../../utils/fileUtil'
import { budgetFormat } from '../../utils/formatterUtil'
import { isEmpty } from 'lodash-es'

export default function AdvanceRefundWinget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)

  const [isShowConfirmTransaction, setIsShowConfirmTransaction] = useState(false)
  const [confirmTransactionMsg, setConfirmTransactionMsg] = useState('')

  const [borrowAmont, setBorrowAmont] = useState(0)
  const [payActive, setPayActive] = useState(props?.schema?.form?.payActive?.value || '')
  const [disabledForm, setDisabledForm] = useState(false)

  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const borrowId = sessionStorage.getItem('borrowId')

  let history = useHistory()

  const handleCallDelete = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await deleteExpenseRequest(borrowId)
      if (response) {
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
        })
        setIsShowConfirmDelete(false)
        sessionRemoveItem('borrowId')
        history.goBack()
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
      setIsShowConfirmDelete(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      // console.log('request', request)
      let response = await saveExpenseRequest(request)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setRequest()
        setIsShowConfirm(false)
        setTimeout(() => {
          if (borrowId) {
            location.reload()
          } else {
            history.goBack()
          }
        }, 1000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
      setIsShowConfirm(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('data', data.table)

    // console.log('data submit ', data)
    // return false

    const tableTotal = data?.table?.length || 0
    const amtRefund = data.table[tableTotal - 2]
    const amtWithdraw = data.table[tableTotal - 1]

    const formData = new FormData()

    formData.append('Id', formSchema.accountingExpenseId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('Period', periodInfo?.periodNumber || 0)
    //formData.append('VoucherNumber', data.voucherNumber || '')
    formData.append('AccountChannel', data.accountChannel || '')
    formData.append('ListBorrowAdvance', data.listBorrowAdvance || '')
    // formData.append('ReceiveMoneyEtc', data.receiveMoneyEtc || '')
    //formData.append('AmountBorrowed', data.amountBorrowed || 0)
    formData.append('BankAccount', data.bankAccount || '')
    formData.append('PayActive', data.payActive || '')
    formData.append('AssetInputReason', data.assetInputReason || '')
    formData.append('ActureReturnDate', moment(data.actureReturnDate).format('YYYY/MM/DD') || '')
    formData.append('CancelCheckBox', data.cancelCheckBox || false)
    formData.append('CancelReason', data.reason || '')
    formData.append('CancelType', data.cancelType || 0)
    formData.append('CancelTranferDate', moment(data.cancelTranferDate).format('YYYY/MM/DD') || '')
    formData.append('CancelDate', moment(data.cancelDate).format('YYYY/MM/DD') || '')


    formData.append('CheckDocNumber', data.checkDocNumber || '')
    formData.append(
      'CheckDocDate',
      data.checkDocDate ? moment(data.checkDocDate).format('YYYY/MM/DD') : ''
    )
    formData.append('IsDraft', false)
    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    const formTable = data.table?.filter((i) => !i.isRowTotal) || []
    // console.log('formTable', formTable)

    if (formTable.length > 0) {
      formTable?.forEach((item, index) => {
        formData.set(`FormTable[${index}].Id`, item.id?.indexOf('addNew') != -1 ? '' : item.id)
        formData.set(`FormTable[${index}].List`, item.list || '')
        formData.set(`FormTable[${index}].ReferenceNumber`, item.referenceNumber || '')
        formData.set(
          `FormTable[${index}].DocumentDate`,
          moment(item.voucherDate).format('YYYY/MM/DD') || ''
        )
        formData.set(`FormTable[${index}].Amount`, item.amount || 0)
        // formData.set(`FormTable[${index}].ReceivedAmount`, item.receivedAmount || 0)
        // formData.set(`FormTable[${index}].Withholding`, item.withholding || 0)
      })
    } else {
      if (!disabledForm) {
        notification.open('error', {
          title: 'กรุณาเพิ่มรายการ อย่างน้อย 1 รายการ',
        })
        return
      }
    }

    setRequest(formData)

    if (amtRefund?.amount > 0) {
      // จำนวนเงินรับคืน
      setConfirmTransactionMsg(
        `รายการคืนเงินทดรองจ่ายมีส่งคืน ${budgetFormat(amtRefund?.amount || 0)} บาท`
      )
      setIsShowConfirmTransaction(true)
      return false
    }

    if (amtWithdraw?.amount > 0) {
      // จำนวนเงินเบิกเพิ่ม
      setConfirmTransactionMsg(
        `รายการคืนเงินทดอรองจ่ายมีเบิกเพิ่ม ${budgetFormat(amtWithdraw?.amount || 0)} บาท`
      )
      setIsShowConfirmTransaction(true)
      return false
    }

    setIsShowConfirm(true)
  }
  const DraftOnSumit = () => {
    const data = getValues()

    console.log('draft data', data)

    if (isEmpty(data.payActive)) {
      notification.open('error', {
        title: 'กรุณาเลือกเลือกรายการยืมเงินทดรองจ่าย ก่อนบันทึกร่าง',
      })
      return
    }

    const tableTotal = data?.table?.length || 0
    const amtRefund = tableTotal >= 2 ? data.table[tableTotal - 2] : null
    const amtWithdraw = tableTotal >= 1 ? data.table[tableTotal - 1] : null

    const formData = new FormData()

    formData.append('Id', formSchema.accountingExpenseId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('Period', periodInfo?.periodNumber || 0)
    formData.append('AccountChannel', data.accountChannel || '')
    formData.append('ListBorrowAdvance', data.listBorrowAdvance || '')
    formData.append('BankAccount', data.bankAccount || '')
    formData.append('PayActive', data.payActive || '')
    formData.append('AssetInputReason', data.assetInputReason || '')

    formData.append(
      'ActureReturnDate',
      data.actureReturnDate ? moment(data.actureReturnDate).format('YYYY/MM/DD') : ''
    )

    formData.append('CancelCheckBox', data.cancelCheckBox || false)
    formData.append('CancelReason', data.reason || '')
    formData.append('CancelType', data.cancelType || 0)
    formData.append('CancelTranferDate', moment(data.cancelTranferDate).format('YYYY/MM/DD') || '')
    formData.append('CancelDate', moment(data.cancelDate).format('YYYY/MM/DD') || '')

    formData.append('CheckDocNumber', data.checkDocNumber || '')

    formData.append(
      'CheckDocDate',
      data.checkDocDate ? moment(data.checkDocDate).format('YYYY/MM/DD') : ''
    )

    formData.append('IsDraft', true)

    if (Array.isArray(data.attachFiles)) {
      data.attachFiles.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })
    }

    if (Array.isArray(data.deleteFileIds)) {
      data.deleteFileIds.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })
    }

    const formTable = data.table?.filter((i) => !i.isRowTotal) || []

    if (formTable.length > 0) {
      formTable.forEach((item, index) => {
        formData.set(
          `FormTable[${index}].Id`,
          item.id?.indexOf('addNew') !== -1 ? '' : item.id || ''
        )
        formData.set(`FormTable[${index}].List`, item.list || '')
        formData.set(`FormTable[${index}].ReferenceNumber`, item.referenceNumber || '')

        formData.set(
          `FormTable[${index}].DocumentDate`,
          item.voucherDate ? moment(item.voucherDate).format('YYYY/MM/DD') : ''
        )

        formData.set(`FormTable[${index}].Amount`, item.amount || 0)
      })
    }

    setRequest(formData)

    if (amtRefund?.amount > 0) {
      setConfirmTransactionMsg(
        `รายการคืนเงินทดรองจ่ายมีส่งคืน ${budgetFormat(amtRefund?.amount || 0)} บาท`
      )
      setIsShowConfirmTransaction(true)
      return
    }

    if (amtWithdraw?.amount > 0) {
      setConfirmTransactionMsg(
        `รายการคืนเงินทดอรองจ่ายมีเบิกเพิ่ม ${budgetFormat(amtWithdraw?.amount || 0)} บาท`
      )
      setIsShowConfirmTransaction(true)
      return
    }

    setIsShowConfirm(true)
  }
  const onPreview = async (accountingExpenseId) => {
    setIsLoading(true)
    startLoading()
    try {
      //var files = filePath?.split('/')
      var file = await downloadExpenseRecordVoucherFile(accountingExpenseId)

      previewFile(file, accountingExpenseId + '.pdf')
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {!formSchema?.disabled ? (
          <>
            <AdvanceRefundForm
              schema={formSchema?.form}
              accountingBorrowAvancesList={formSchema.accountingBorrowAvances}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              setIsEnableEdit={setIsEnableEdit}
              borrowAmont={borrowAmont}
              setBorrowAmont={setBorrowAmont}
              payActive={payActive}
              setPayActive={setPayActive}
              disabledForm={disabledForm}
              setDisabledForm={setDisabledForm}
              projectStartDate={formSchema?.projectInfo?.projectStartDate}
              projectEndDate={formSchema?.projectInfo?.projectEndDate}
            />
          </>
        ) : (
          <>
            <AdvanceRefundView
              schema={formSchema?.form}
              accountingBorrowAvancesList={formSchema.accountingBorrowAvances}
              borrowAmont={borrowAmont}
              setBorrowAmont={setBorrowAmont}
              payActive={payActive}
              setPayActive={setPayActive}
              disabledForm={disabledForm}
              setDisabledForm={setDisabledForm}
            />
          </>
        )}

        <AdvanceRefundTable
          schema={formSchema?.form?.formTable}
          activityRelationsList={formSchema?.activityRelations}
          isReceiveAnnuity={formSchema?.form?.isReceiveAnnuity}
          assetInputReason={formSchema?.form?.assetInputReason}
          assetInputAlertDescription={formSchema?.form?.assetInputAlertDescription}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          isEnableEdit={!formSchema?.form?.isReceiveAnnuity || isEnableEdit}
          borrowAmont={borrowAmont}
          setBorrowAmont={setBorrowAmont}
          payActive={payActive}
          setPayActive={setPayActive}
          disabledForm={disabledForm}
          isViewMode={formSchema?.disabled}
          isAddDisabled={formSchema?.form?.isAddDisabled}
        />

        <>
          <div>
            <br />
            <Row>
              {isError && <Message showIcon type="error" description={isError} />}
              <Col lg={12} md={12} sm={24} xs={24}>
                {/* 23/10/2024 พี่ตุ๊ให้เอากลับมา  */}
                {!formSchema?.disabled && (
                  <Button
                    color="red"
                    appearance="link"
                    onClick={() => setIsShowConfirmDelete(true)}
                    disabled={
                      formSchema?.form?.enableSaveDraft ||
                      formSchema?.form?.isReceiveAnnuity ||
                      !borrowId ||
                      isLoading ||
                      formSchema?.form?.isDeleteDisabled
                    }
                  >
                    <Icon icon="trash" size="lg" /> ลบเอกสาร
                  </Button>
                )}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {formSchema?.accountingExpenseId && (
                  <Button
                    color="blue"
                    appearance="link"
                    disabled={formSchema?.form?.enableSaveDraft || isLoading}
                    onClick={() => {
                      onPreview(formSchema.accountingExpenseId)
                    }}
                    style={{
                      marginRight: 10,
                      marginBottom: 10,
                    }}
                  >
                    <Icon icon="eye" size="lg" /> ใบสำคัญจ่าย
                  </Button>
                )}

                {!formSchema?.disabled && (
                  <>
                    {formSchema?.form?.enableSaveDraft && (
                      <SaveButton
                        disabled={isLoading || formSchema?.form?.isEditDisabled}
                        onClick={DraftOnSumit}
                      >
                        บันทึกร่าง
                      </SaveButton>
                    )}
                    <SaveButton
                      disabled={isLoading || formSchema?.form?.isEditDisabled}
                      onClick={handleSubmit(onSubmit)}
                    >
                      บันทึก
                    </SaveButton>
                    <CancelButton
                      onClick={() => {
                        history.goBack()
                      }}
                    >
                      ยกเลิก
                    </CancelButton>
                  </>
                )}
              </Col>
            </Row>
          </div>
        </>
      </Panel>

      <ConfirmWidget
        title={'ยืนยันการบันทึก'}
        show={isShowConfirm}
        //detail={'ยืนยันการบันทึก'}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />

      <ConfirmWidget
        title={'ยืนยันทำรายการ'}
        show={isShowConfirmTransaction}
        detail={confirmTransactionMsg}
        onCancle={() => setIsShowConfirmTransaction(false)}
        onConfirm={handleCallService}
      />

      <ConfirmWidget
        title={'ยืนยันลบเอกสาร'}
        show={isShowConfirmDelete}
        //detail={'ยืนยันลบเอกสาร'}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleCallDelete}
      />
    </>
  )
}
